export default "__VITE_ASSET__2tZz1bC7__"